import {Inject, Pipe, PipeTransform} from '@angular/core';
import {MonitoringAlarm} from '../models/monitoring-alarm';
import { ProjectConfiguration } from '../../project/models/project-configuration';


@Pipe({
  name: 'canRaiseIncident'
})
export class CanRaiseIncidentPipe implements PipeTransform {

  constructor(
      @Inject ( 'ConfigurationStoreService' ) private configurationStoreService: any
  ) {

  }

  transform(alarms: MonitoringAlarm[]): boolean {
    if ((alarms && alarms.length) > 1 || alarms && alarms[0] && alarms[0].incidentId) {
      return false;
      } else {
        const projectConfiguration: ProjectConfiguration = alarms && alarms[0] && this.configurationStoreService.getProjectConfiguration(alarms[0].projectId);
        return projectConfiguration && projectConfiguration.remedyForceConfiguration && projectConfiguration.remedyForceConfiguration.rfEnabled;
      }
    }
}
